import React, { useEffect, useState } from 'react';
import EmployeeDetails from '../../components/EmployeeDetails/EmployeeDetails';
import { getAuthHeaders } from '../../utils/auth';
import axios from 'axios';
import Loader from '../../components/Loader/Loader';

export default function ProfilePage({ userProfile, currentView }) {

  const [profile, setProfile] = useState([]);
  const [loading, setIsLoading] = useState(false);

  const formatCurrency = (amount) => {
    if (amount == null) return 'KD 0.000';
    return `KD ${Number(amount).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}`;
  };
  // Utility function for role display names
  const getRoleDisplayName = (role) => {
    if (role === null || role === undefined) return 'Staff';

    // Handle numeric role codes from Dynamics 365
    const roleMap = {
      100000000: 'Staff',
      100000001: 'Manager',
      100000002: 'Admin',
      100000003: 'Super'
    };

    // If it's a number, convert to string and look up
    if (typeof role === 'number') {
      return roleMap[role] || 'Staff';
    }

    // If it's already a string, return as is or capitalize first letter
    if (typeof role === 'string') {
      return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
    }

    return 'Staff';
  };

  // Utility function for role colors
  const getRoleColor = (role) => {
    const displayName = getRoleDisplayName(role);
    const colorMap = {
      'Staff': 'staff',
      'Manager': 'manager',
      'Admin': 'admin',
      'Super': 'super'
    };
    return colorMap[displayName] || 'staff';
  };

  const getStatusColor = (status) => {
    const colors = {
      'Active': 'active',
      'On Leave': 'on-leave',
      'Exited': 'exited'
    };
    return colors[status] || 'active';
  };

  const getGroupColor = (group) => {
    const colors = {
      'FOH': 'foh',
      'Management': 'management',
      'Staff': 'staff',
      'BOH': 'boh'
    };
    return colors[group] || 'staff';
  };

  const fetchProfile = async () => {

    try {
      setIsLoading(true);
      const headers = await getAuthHeaders();
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/employees/me`, {
        headers,

      });
      setProfile(response.data.employees);
    } catch (error) {
      console.error('Error fetching employees:', error);
      // Handle authentication errors
      if (error.message && error.message.includes('sign in')) {
        alert('Authentication required. Please sign in with Microsoft.');
        window.location.reload();
      }
    } finally {
      setIsLoading(false);
    }
  };


  const canViewOwnProfile =
    userProfile?.role === 'manager' ||
    userProfile?.role === 'admin' ||
    userProfile?.role === 'super';

  useEffect(() => {
    const handler = setTimeout(() => {
      if (canViewOwnProfile && currentView === 'profile') {
        fetchProfile();
      }
    }, 500);
    return () => clearTimeout(handler);
  }, [currentView, canViewOwnProfile]);

  return (
    <div className="w-full min-w-0">
      <div className="section-header">
        <>
          <h2>My Profile</h2>
        </>
      </div>
      {loading ? 
        <Loader /> : 
        <EmployeeDetails
          employee={ profile[0]}
          userProfile={userProfile}
          formatCurrency={formatCurrency}
          getRoleDisplayName={getRoleDisplayName}
          getRoleColor={getRoleColor}
          getGroupColor={getGroupColor}
          getStatusColor={getStatusColor}
          currentView={currentView}
        />
      }
    </div>
  );
}